import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaSchool } from "react-icons/fa";
import { FaSliders } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa";
import { FaChartPie } from "react-icons/fa";
import { FaUniversity } from "react-icons/fa";
import { FaList } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

function Sidebar() {
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [challanOpen, setChallanOpen] = useState(false);
  const [notFoundOpen, setNotFoundOpen] = useState(false);
  const [demogarphy, setDemography] = useState(false);

  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const contentRef3 = useRef(null);
  const contentRef4 = useRef(null);
  const contentRef5 = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const noticeDropdown = () => {
    setNoticeOpen(!noticeOpen);
  };
  const reportsDropdown = () => {
    setReportsOpen(!reportsOpen);
  };

  const challanDropdown = () => {
    setChallanOpen(!challanOpen);
  };

  const notFoundDropdown = () => {
    setNotFoundOpen(!notFoundOpen);
  };
  const demographydropdown = () => {
    setDemography(!demogarphy);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = noticeOpen
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [noticeOpen]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = reportsOpen
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [reportsOpen]);

  useEffect(() => {
    if (contentRef3.current) {
      contentRef3.current.style.maxHeight = challanOpen
        ? `${contentRef3.current.scrollHeight}px`
        : "0px";
    }
  }, [challanOpen]);

  useEffect(() => {
    if (contentRef4.current) {
      contentRef4.current.style.maxHeight = notFoundOpen
        ? `${contentRef4.current.scrollHeight}px`
        : "0px";
    }
  }, [notFoundOpen]);

  useEffect(() => {
    if (contentRef5.current) {
      contentRef5.current.style.maxHeight = demogarphy
        ? `${contentRef5.current.scrollHeight}px`
        : "0px";
    }
  }, [demogarphy]);

  const isNoticeActive = [
    "/intermediate-admin-upload-notice-class-xi",
    "/intermediate-admin-upload-notice-class-xii",
  ].includes(location.pathname);

  const isReportsActive = [
    "/intermediate-admin-class-xi-reports",
    "/intermediate-admin-class-xii-reports",
  ].includes(location.pathname);

  const isChallanActive = [
    "/intermediate-admin-challan-cancel-class-xi",
    "/intermediate-admin-challan-cancel-class-xii",
  ].includes(location.pathname);

  const isNotFoundActive = [
    "/intermediate-not-found-class-xi",
    "/intermediate-not-found-class-xii",
  ].includes(location.pathname);
  const demographydetails = [
    // "/secondary-not-found-class-ix",
    "/intermediate-demographic-details-update",
  ].includes(location.pathname);
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        {permissions[0].caN_VIEW === true && (
          <li
            className={`nav-item ${
              location.pathname === "/intermediate-admin-dashboard"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/intermediate-admin-dashboard");
              }}
            >
              <i className="icon-grid menu-icon" />
              <span className="menu-title">Dashboard</span>
            </a>
          </li>
        )}
        {permissions[1].caN_VIEW === true && (
          <li
            className={`nav-item ${
              location.pathname === "/intermediate-admin-school-list"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/intermediate-admin-school-list");
              }}
            >
              <i className="menu-icon">
                <FaSchool />
              </i>
              <span className="menu-title">School List</span>
            </a>
          </li>
        )}
        {permissions[2].caN_VIEW === true && (
          <li className={`nav-item ${isNoticeActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                noticeDropdown();
              }}
              style={{ cursor: "pointer" }}
              aria-expanded={noticeOpen}
              aria-controls="auth1"
            >
              <i className="menu-icon">
                <FaFilePdf />
              </i>
              <span className="menu-title">Upload Notice</span>&nbsp;&nbsp;
              <i className="menu-arrow" />
            </a>
            <div className="custom-collapse" id="auth1" ref={contentRef1}>
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-upload-notice-class-xi");
                    }}
                  >
                    Class XI
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-upload-notice-class-xii");
                    }}
                  >
                    Class XII
                  </a>
                </li>
              </ul>
            </div>
          </li>
        )}
        {permissions[3].caN_VIEW === true && (
          <li
            className={`nav-item ${
              location.pathname === "/intermediate-admin-ticker-master"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/intermediate-admin-ticker-master");
              }}
            >
              <i className="menu-icon">
                <FaSliders />
              </i>
              <span className="menu-title">Ticker Master</span>
            </a>
          </li>
        )}
        {permissions[4].caN_VIEW === true && (
          <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                reportsDropdown();
              }}
              style={{ cursor: "pointer" }}
              aria-expanded={reportsOpen}
              aria-controls="auth2"
            >
              <i className="menu-icon">
                <FaChartPie />
              </i>
              <span className="menu-title">Reports</span>&nbsp;&nbsp;
              <i className="menu-arrow" />
            </a>
            <div className="custom-collapse" id="auth2" ref={contentRef2}>
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-class-xi-reports");
                    }}
                  >
                    Class XI
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-class-xii-reports");
                    }}
                  >
                    Class XII
                  </a>
                </li>
              </ul>
            </div>
          </li>
        )}
        {permissions[7].caN_VIEW === true && (
          <li
            className={`nav-item ${
              location.pathname === "/intermediate-admin-add-school"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/intermediate-admin-add-school");
              }}
            >
              <i className="menu-icon">
                <FaUniversity />
              </i>
              <span className="menu-title">Add School</span>
            </a>
          </li>
        )}
        {permissions[6].caN_VIEW === true && (
          <li className={`nav-item ${isChallanActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                challanDropdown();
              }}
              style={{ cursor: "pointer" }}
              aria-expanded={challanOpen}
              aria-controls="auth3"
            >
              <i className="menu-icon text-danger">
                <MdCancel />
              </i>
              <span className="menu-title text-danger">Challan Cancel</span>
              &nbsp;&nbsp;
              <i className="menu-arrow text-danger" />
            </a>
            <div className="custom-collapse" id="auth3" ref={contentRef3}>
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-challan-cancel-class-xi");
                    }}
                  >
                    Class XI
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-admin-challan-cancel-class-xii");
                    }}
                  >
                    Class XII
                  </a>
                </li>
              </ul>
            </div>
          </li>
        )}
        {permissions[8].caN_VIEW === true && (
          <li className={`nav-item ${isNotFoundActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                notFoundDropdown();
              }}
              style={{ cursor: "pointer" }}
              aria-expanded={notFoundOpen}
              aria-controls="auth4"
            >
              <i className="menu-icon text-danger">
                <FaList />
              </i>
              <span className="menu-title text-danger">Data Not Found</span>
              &nbsp;&nbsp;
              <i className="menu-arrow text-danger" />
            </a>
            <div className="custom-collapse" id="auth4" ref={contentRef4}>
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-not-found-class-xi");
                    }}
                  >
                    Class XI
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-not-found-class-xii");
                    }}
                  >
                    Class XII
                  </a>
                </li>
              </ul>
            </div>
          </li>
        )}
        {permissions[9].caN_VIEW === true && (
          <li className={`nav-item ${demographydetails ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                demographydropdown();
              }}
              style={{ cursor: "pointer" }}
              aria-expanded={demogarphy}
              aria-controls="auth5"
            >
              <i className="menu-icon text-danger">
                <FaList />
              </i>
              <span className="menu-title text-danger">Update Demography</span>
              &nbsp;&nbsp;
              <i className="menu-arrow text-danger" />
            </a>
            <div className="custom-collapse" id="auth5" ref={contentRef5}>
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-demographic-details-update-xi");
                    }}
                  >
                    Class XI
                  </a>
                </li>
                 <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-gender-details-update-xi");
                    }}
                  >
                    Class XI Gender Change
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/intermediate-demographic-details-update");
                    }}
                  >
                    Class XII
                  </a>
                </li>
              </ul>
            </div>
          </li>
        )}
        {permissions[10]?.caN_VIEW === true && (
          <li
            className={`nav-item ${
              location.pathname === "/intermediate-admin-ia-reports"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/intermediate-admin-ia-reports");
              }}
            >
              <i className="icon-download menu-icon" />
              <span className="menu-title">Download IA Reports</span>
            </a>
          </li>
        )}
        {/* <li
          className={`nav-item ${
            location.pathname === "/intermediate-demographic-details-update"
              ? "active"
              : ""
          }`}
        >
          <a
            className="nav-link  back-g"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/intermediate-demographic-details-update");
            }}
          >
            <i className="fa fa-edit menu-icon" />
            <span className="menu-title">
              Update Demographic<br></br> Details
            </span>
          </a>
        </li> */}
      </ul>
    </nav>
  );
}

export default Sidebar;
